jQuery(document).ready(function ($) {
    // FAQ Atom
    $('.questions .item .title').click(function(e) {
        e.preventDefault();

        var $this = $(this),
            $questions = $('.questions .item'),
            $parent = $this.parent();

        if (!$parent.hasClass('item--active')) {
            $questions.removeClass('item--active');
        }

        $parent.toggleClass('item--active');
    });
});